import React, { ReactNode } from 'react';
import { IconButton } from '@mui/material';
import styles from './style.module.scss';

//#region Types
export interface CircularIconButtonProps {
  /** Icon to display (ReactNode or MUI Icon component) */
  icon: ReactNode;
  /** Click handler */
  onClick: () => void;
  /** Aria label for accessibility */
  ariaLabel: string;
  /** Whether button is in active/selected state */
  isActive?: boolean;
  /** Additional CSS class */
  className?: string;
}
//#endregion

/**
 * CircularIconButton - Circular icon button with white background
 * 
 * Design: 42px circle, white background, box shadow, 2px white border
 * Used in sticky footer and other action contexts
 * 
 * @example
 * ```tsx
 * <CircularIconButton
 *   icon={<ShareIcon />}
 *   onClick={() => share()}
 *   ariaLabel="Share listing"
 * />
 * ```
 */
export default function CircularIconButton({
  icon,
  onClick,
  ariaLabel,
  isActive = false,
  className,
}: CircularIconButtonProps) {
  return (
    <IconButton
      onClick={onClick}
      aria-label={ariaLabel}
      className={`${styles.component} ${isActive ? styles.active : ''} ${className || ''}`}
      size="small"
    >
      {icon}
    </IconButton>
  );
}
